var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistIssue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.12,
    height: 20.108,
    viewBox: "0 0 22.12 20.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_151",
    "data-name": "Tracciato 151",
    d: "M24.017,21.659,14,3.534a1.057,1.057,0,0,0-1.762,0L2.167,21.659a1.007,1.007,0,0,0,.856,1.51H23.162a1.007,1.007,0,0,0,.856-1.51ZM13.092,19.645A1.007,1.007,0,1,1,14.1,18.638,1.007,1.007,0,0,1,13.092,19.645ZM14.1,15.617a1.007,1.007,0,0,1-2.014,0V11.086a1.007,1.007,0,0,1,2.014,0Z",
    transform: "translate(-2.032 -3.061)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIssue);
export default __webpack_public_path__ + "static/media/ChecklistIssue.17f8f827a498e5d93077039bd99fcd9a.svg";
export { ForwardRef as ReactComponent };